import { computed } from "vue";
import { useCookieConsentStore } from "~/layers/base/stores/cookieConsentStore";

export const useCookieConsent = () => {
	const store = useCookieConsentStore();

	return {
		decision: computed(() => store.decision),
		categories: computed(() => store.categories),
		hasDecided: computed(() => store.hasDecided),
		settingsOpen: computed(() => store.settingsOpen),
		acceptAll: () => store.acceptAll(),
		rejectAll: () => store.rejectAll(),
		savePreferences: store.savePreferences.bind(store),
		revoke: () => store.revoke(),
		openSettings: () => store.openSettings(),
		closeSettings: () => store.closeSettings()
	};
};
